import {IProductPriceObject} from '../IProduct';
import {ICustomizedProductPriceInfo} from './ICustomizedProduct';

// TODO: This logic will be rechecked in the scope of this task: https://thelevelgroup.atlassian.net/browse/DHP-616

/**
 * Represents CustomizedProductPriceModel
 */
class CustomizedProductPriceModel {
	private priceInfo: ICustomizedProductPriceInfo;

	/**
	 * @construct
	 */
	constructor(priceInfo: ICustomizedProductPriceInfo) {
		this.priceInfo = priceInfo;
	}

	/**
	 * Returns the sales product price
	 * @return {IProductPriceObject}
	 */
	getSales () {
		return this.getMinPrice();
	}

	/**
	 * Returns the list product price
	 * @return {IProductPriceObject}
	 */
	getList () {
		const minPrice = this.getMinPrice();
		const maxPrice = this.getMaxPrice();

		if (minPrice && maxPrice && minPrice.value !== maxPrice.value) {
			return maxPrice;
		} else {
			return null;
		}
	}

	/**
	 * Returns the maximum price
	 * @returns {IProductPriceObject} - the maximum price
	 */
	getMaxPrice() : IProductPriceObject {
		return {
			value: this.priceInfo?.totalPrice,
			currency: this.getCurrency(),
			pricebook: 'default'
		};
	}

	/**
	 * Returns the minimal price taking into consideration all the variants
	 * @return {IProductPriceObject} the minimal price
	 */
	getMinPrice() : IProductPriceObject {
		return {
			value: this.priceInfo?.totalPrice,
			currency: this.getCurrency(),
			pricebook: 'default'
		};
	}

	/**
	 * Returns the discount percent of sales price
	 * @return {number} the discount percent
	 */
	getDiscountPercent (): number {
		const minPrice: IProductPriceObject = this.getMinPrice();
		const maxPrice: IProductPriceObject = this.getMaxPrice();

		return ((maxPrice.value - minPrice.value) / maxPrice.value) * 100;
	}

	/**
	 *
	 * @returns
	 */
	getCurrency (): string {
		return this.priceInfo.currencyCode;
	}
}

export default CustomizedProductPriceModel;
